import { Injectable } from '@angular/core';
import { CallService, LeadService } from '../lib';
import { ToastService } from './toast/toast.service';
import { AppInsightsService } from './app-insights.service';
import { AdmissionUICommonDataService } from './admission-ui/admission-ui-common-data.service';
import { GenesysCloudService } from './genesys-cloud.service';

@Injectable({
  providedIn: 'root'
})
export class PhoneService {
  constructor(
    private readonly callService: CallService,
    private readonly toastService: ToastService,
    private readonly appInsightService: AppInsightsService,
    private readonly leadService: LeadService,
    private readonly genesysCloudService: GenesysCloudService,
    private readonly admissionsService: AdmissionUICommonDataService
  ) { }

  makeCall(phoneNumber: string, localTouch: boolean): Promise<string | undefined> {
    return new Promise((resolve, reject) => {
      this.callService.apiCallOutboundPost({ phone: phoneNumber, isLocalTouch: localTouch })
        .subscribe({
          next: (response) => {
            resolve(this.handleSuccess(response));
          },
          error: (error) => {
            resolve(this.handleError(error));
          },
        });
    });
  }

  isValidNumber(phoneNumber: string): boolean {
    return phoneNumber?.length === 10 && !isNaN(Number(phoneNumber));
  }

  isValidStudent(phoneNumber: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.leadService.apiLeadGetbyPhoneNumberPost({ phoneNumber }).subscribe({
        next: (data) => {
          if (data?.length > 0) {
            data = data.filter((lead: any) => !(lead?.phoneIsDNC === true || lead?.workPhoneIsDNC === true
              || lead?.otherPhoneIsDNC === true || lead?.mobilePhoneIsDNC === true));
          }
          let isStudent = data?.length > 0;
          resolve(isStudent);
        },
        error: (error) => {
          this.appInsightService.logException(error);
          resolve(false);
          reject(error as Error);
        }
      })
    });
  }

  formatPhoneNumber(phoneNumber: string): string {
    return phoneNumber?.replace(/\D/g, '')?.substring(0, 10);
  }

  appendToPhoneNumber(phoneNumber: string, digit: number): string {
    if (phoneNumber?.length === 0 && digit === 0) {
      return phoneNumber;
    }
    if (phoneNumber?.length < 10) {
      phoneNumber += digit;
    }
    return phoneNumber;
  }


  validateInput(event: KeyboardEvent, phoneNumber: string): boolean {
    const isNumericKey = /^\d+$/.test(event.key);
    // If phoneNumber is empty, disallow '0' as the first digit
    if (phoneNumber?.length === 0) {
      return isNumericKey && event.key !== '0';
    }

    return isNumericKey;
  }

 
  disconnect(converstionId: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.genesysCloudService.disconnectCall(converstionId)
        .subscribe({
          next: (response) => {
            if (response) return resolve(true);
            resolve(false);
          },
          error: (error) => {
            return resolve(false);
          }
        });
    });
  }

  
  decline(converstionId: string,agentParticipantId: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.genesysCloudService.declineCallConversationparticipant(converstionId,agentParticipantId)
        .subscribe({
          next: (response) => {
            if (response) return resolve(true);
            resolve(false);
          },
          error: (error) => {
            return resolve(false);
          }
        });
    });
  }

  
  voiceMail(converstionId: string,agentParticipantId: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.genesysCloudService.replaceCallConversationparticipant(converstionId,agentParticipantId)
        .subscribe({
          next: (response) => {
            if (response) return resolve(true);
            resolve(false);
          },
          error: (error) => {
            return resolve(false);
          }
        });
    });
  }

  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedInput = clipboardData.getData('text');
    const numericInput = pastedInput.replace(/\D/g, '');
    if (numericInput) {
      const inputElement = event.target as HTMLInputElement;
      if (inputElement != null) {
        const currentValue = inputElement.value;
        const startPos = inputElement.selectionStart ?? 0;
        const endPos = inputElement.selectionEnd ?? 0;
        inputElement.value = currentValue.slice(0, startPos) + numericInput + currentValue.slice(endPos);
        inputElement.setSelectionRange(startPos + numericInput.length, startPos + numericInput.length);

        inputElement.setSelectionRange(startPos + numericInput.length, startPos + numericInput.length);

        // Manually trigger input event to ensure change detection
        const event = new Event('input', { bubbles: true });
        inputElement.dispatchEvent(event);

      }
    }
  }

  placeAdmissionsOutboundCallByPhoneNumber(phoneNumber: string): Promise<string | undefined> {
    return new Promise((resolve, reject) => {
      this.admissionsService.dial(0, phoneNumber, 0, 0, 0, null, null).subscribe({
        next: (response) => {
          resolve(this.handleSuccess(response));
        },
        error: (error) => {
          resolve(this.handleError(error));
        },
      })
    });
  }

  private handleSuccess = (response: any) => {
    if (response.id) {
      this.toastService.show({ body: 'Call successfully placed', classname: 'bg-success text-light', delay: 5000, header: 'Success' });
      return response.id;
    } else {
      this.toastService.show({ body: 'Call failed - ' + response.error, classname: 'bg-danger text-light', delay: 5000, header: 'Failure' });
      return undefined;
    }
  };
  private handleError = (error: any) => {
    this.toastService.show({ body: 'Call failed server error.', classname: 'bg-danger text-light', delay: 5000, header: 'Failure' });
    this.appInsightService.logException(error);
    return undefined;
  };
}
